<template>
  <v-row class="categories_cards_b2b d-flex justify-space-between">
      <v-col v-for="card in categoryOptions" :key="card.cardId" class="container_cards" cols="12" sm="3">
            <v-card class="div_card_options d-flex flex-column text-left">
                <div class="subcard_div d-flex flex-column">
                    <img class="card_img" :src="card.icon" alt="card_icon" onload="SVGInject(this)" />
                    <span class="">{{card.title}}</span>
                    <div class="list_options" v-for="list in card.listOptions" :key="list.id">
                        <h5 @click="clickOnLabel(list.id, list.request)">{{list.title}}</h5>
                    </div>
                </div>
            </v-card>
      </v-col>
  </v-row>
</template>

<script>
export default {
    props: {
        /**
        *   @param Array required payload structure
        *   [
        *      {
        *          title: 'Manutenção', icon: '/images/_SVGs/manutencao.svg', url: '',
        *          listOptions: [
        *               { title: 'Plano de Manutenção da Marca', id: 1, request: 'manual', manualId: '1',},
        *               { title: 'Reposição do Intervalo de Serviço', id: 2},
        *              { ... },
        *           ]
        *      },
        *      (...)
        *  ]
        */
       categoryOptions: {
            type: [Array, Object],
            required: true
        }
    },

    methods: {
        clickOnLabel(id, request) {
            if(request === 'category-tech-manual') {
                const url = `/tech-info/categories-tech-manuals/${request}/${id}`;
                return this.$router.push(url);
            }
            if(request === 'maintenance-plan') {
                const url = `/tech-info/maintenance-plan`;
                return this.$router.push(url);
            }

            const url = `/tech-info/${request}/${id}`;
            this.$router.push(url);
        }
    }

}
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.categories_cards_b2b {

    .container_cards {
        width: 100%;

        .div_card_options {
            border-radius: 10px;
            padding: 25px;
            min-height: 280px;

            .subcard_div {
                .card_img {
                    /* color: $grey-dark; */
                    height: 40px;
                    margin-top: 10px;
                    width: 40px;
                }

                span {
                    font-size: 20px;
                    font-weight: 500;
                }

                h5 {
                    margin-top: 10px;
                    display: block;
                    font-size: 12px;
                    line-height: 17px;
                    letter-spacing: 0.28px;
                    cursor: pointer;
                }

                .list_options {
                    &:hover {
                        h5 {
                            &:last-child {
                                color: var(--v-primary-base);
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>
